export const BOOKING_STATUS_SUCCESSFUL = 'successful';
export const BOOKING_STATUS_FAILED = 'failed';
export const BOOKING_STATUS_PENDING = 'pending';
